import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from 'app/store'
import { clearFilters } from 'app/thunks'
import { QueriedObject } from 'types'

export interface SearchState {
  search: string
  toggles: { id: string; label: string; checked: boolean }[]
  status: 'idle' | 'loading' | 'failed'
  currentUri: string
  navObject: QueriedObject | null
  type: 'products' | 'brands';
}

const initialState: SearchState = {
  search: '',
  toggles: [],
  status: 'idle',
  currentUri: '',
  navObject: null,
  type: 'products',
}

type SearchSubmitType = {
  search: string
  type: 'products' | 'brands'
}

export const searchSlice = createSlice({
  name: 'search',
  initialState,
  reducers: {
    clearAll: (state) => {
      state.search = ''
    },
    searchSubmit: (state, { payload }: PayloadAction<SearchSubmitType>) => {
      state.search = payload.search
      state.type = payload.type
    },
    uriChanged: (state, { payload }: PayloadAction<string>) => {
      state.currentUri = payload
    },
  },
  extraReducers: (builder) => {
    builder.addCase(clearFilters.pending, (state) => {
      state.search = ''
    })
  },
})

export const { searchSubmit, clearAll, uriChanged } = searchSlice.actions

export const searchSelector = (state: RootState) => state[searchSlice.name]

export default searchSlice
